import { render, staticRenderFns } from "./FaqCategoriesNested.vue?vue&type=template&id=c060bc06&scoped=true&"
import script from "./FaqCategoriesNested.vue?vue&type=script&lang=js&"
export * from "./FaqCategoriesNested.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategoriesNested.vue?vue&type=style&index=0&id=c060bc06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060bc06",
  null
  
)

export default component.exports